<template>
    <div class="page-content">
        <div class="page-top">
            <div class="page-top-content">
                <el-form inline label-position="top">
                    <el-form-item label="地区">
                        <el-select filterable v-model="searchForm.area_id" clearable>
                            <el-option v-for="(item,index) in cityList"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="房源类型">
                        <el-select v-model="searchForm.screen_type" clearable>
                            <el-option v-for="(item,index) in houseType"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="房间类型">
                        <el-select v-model="searchForm.screen_room" clearable>
                            <el-option v-for="(item,index) in roomType"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="按配套设施搜索">
                        <el-select v-model="searchForm.screen_facility" multiple collapse-tags clearable>
                            <el-option v-for="(item,index) in facility"
                                       :key="index"
                                       :label="item.name"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="margin-top: 50px;">
                        <el-button type="primary" @click="handlerSearch">搜索</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="card-content">
            <HouseCard v-for="item in list" :key="item.id" :item="item"></HouseCard>
            <el-alert v-if="list.length<=0" title="暂无相关数据~" class="mt-20" center :closable="false" type="warning" show-icon></el-alert>
        </div>
        <div v-if="!finish" class="load-content"><i class="el-icon-loading"></i></div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import HouseCard from "@/components/HouseCard";

    export default {
        name: "tokyoHouse",
        components: {HouseCard},
        data() {
            return {
                finish: false,
                list: [],
                houseType: [],
                roomType: [],
                facility: [],
                searchForm: {
                    area_id: '',
                    screen_type: '',
                    screen_room: '',
                    screen_facility: [],
                    page: 1,
                    nums: 12
                }
            }
        },
        created() {
            this.getLandlordAdd()
            this.getlandlordIndex()
            this.$eventBus.$on('onBottom', this.handlerBottom)
        },
        beforeDestroy() {
            this.$eventBus.$off('onBottom', this.handlerBottom)
        },
        computed: {
            ...mapState(['cityList'])
        },
        methods: {
            handlerSearch(){
                this.finish = false;
                this.searchForm.page = 1;
                this.getlandlordIndex()
            },
            async getLandlordAdd() {
                let [e, data] = await this.$api.getLandlordAddApi();
                if (data.code === 200) {
                    this.houseType = data.result.house;
                    this.roomType = data.result.room;
                    this.facility = data.result.facility;
                }
            },
            async getlandlordIndex() {
                let [e, data] = await this.$api.getlandlordIndexApi(this.searchForm)
                if (data.code !== 200) return;
                if (this.searchForm.page === 1) {
                    this.list = data.result.house;
                } else {
                    this.list = [...this.list, ...data.result.house]
                }
                this.finish = data.result.house.length < this.searchForm.nums;
            },
            handlerBottom() {
                if (this.finish) return;
                this.searchForm.page++;
                this.getlandlordIndex();
            }
        }
    }
</script>

<style scoped lang="less">
    .page-top {
        width: 100%;
        background-color: #ffffff;
        position: sticky;
        top: 80px;
        left: 0;
        z-index: 9;
        border-bottom: 1px solid #e2e2e2;

        .page-top-content {
            width: 1200px;
            margin: auto;
            display: flex;
            justify-content: flex-start;
            align-items: center;
        }
    }
</style>
